var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{staticClass:"tabs",attrs:{"type":_vm.type},on:{"tab-click":_vm.handleTabClick},model:{value:(_vm.internalActiveTab),callback:function ($$v) {_vm.internalActiveTab=$$v},expression:"internalActiveTab"}},_vm._l((_vm.tabs),function(tab){return _c('el-tab-pane',{key:tab.name,attrs:{"label":tab.label,"name":tab.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }